export const gameWidth = 8
export const gameHeight = 15
export const backgroundColor = 'aqua'
export const gameCellSize = () =>
  window.innerWidth < 0.62 * window.innerHeight
    ? window.innerWidth / (gameWidth + 2)
    : window.innerHeight / gameHeight
